export const CREATE_CLIENT_ADD_LISTING = "CREATE_CLIENT_ADD_LISTING"
export const CREATE_CLIENT_ADD_LISTING_SUCCESS = "CREATE_CLIENT_ADD_LISTING_SUCCESS"
export const CREATE_CLIENT_ADD_LISTING_FAIL = "CREATE_CLIENT_ADD_LISTING_FAIL"


export const GET_CLIENT_ADD_LISTING = "GET_CLIENT_ADD_LISTING"
export const GET_CLIENT_ADD_LISTING_SUCCESS = "GET_CLIENT_ADD_LISTING_SUCCESS"
export const GET_CLIENT_ADD_LISTING_FAIL = "GET_CLIENT_ADD_LISTING_FAIL"